// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1Vwnz","footer":"ModalError_footer__3bW28"};